<div class="container">
    <div class="wrapper">
        <!-- <h1 class="pageTitle"> {{pageTitle}}</h1> -->
        <hr>
        <div class="card mb-3 services-list" *ngFor="let service of servicesList" tabindex="-1">
            <div>
                <!-- <div class="bb-image">
                    <div class="service-image" [style.background]="'url(' + service.image?.url + ')'"></div>
                </div> -->
                <div class="row service-item-content" tabindex="0"
                    [ngClass]="{'selected-service': selectedService?.id === service?.id}">
                    <h3 class="col-sm-12 pb-4">{{service.name}}</h3>
                    <span class="col-sm-12" [innerHTML]="service.description"></span>
                    <div class="col-sm-12">
                        <button class="btn btn-primary float-right mt-4 btn-panellink" (click)="selectService(service)">Select a
                            date and
                            time</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>